import { TextField } from "@mui/material";

import { useDebouncedCallback } from "@/shared/hooks";
import {
  type PanelState,
  actions,
  useVizDispatch,
} from "@/shared/state/visualization";

import styles from "./PanelTitle.module.css";

interface BasicPanelSettingsProps {
  state: PanelState;
}

export function PanelTitle({ state }: BasicPanelSettingsProps) {
  const dispatch = useVizDispatch();

  const handleTitleChange = useDebouncedCallback((newTitle: string) => {
    dispatch(actions.setPanelTitle(state.id, newTitle));
  }, 300); // 300ms debounce delay chosen through trial and error

  return (
    <TextField
      defaultValue={state.title || ""}
      fullWidth
      inputProps={{
        className: styles.input,
      }}
      InputLabelProps={{
        className: styles.input,
      }}
      key={state.id}
      label="Panel Title"
      margin="dense"
      onChange={(e) => handleTitleChange(e.target.value)}
      size="small"
    />
  );
}
